import script from "./ChatTypingIndicator.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatTypingIndicator.vue?vue&type=script&setup=true&lang=js"

import "./ChatTypingIndicator.vue?vue&type=style&index=0&id=540e4c7b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-540e4c7b"]])

export default __exports__